import { useState, useRef, useEffect } from "react";
import PrintLink from '../PrintLink/PrintLink';
import HelpModal from '../HelpModal/HelpModal';
import ShareModal from '../ShareModal/ShareModal';
import FeedbackModal from '../FeedbackModal/FeedbackModal';
import { ChamProjectsOpenButton, ChamProjectsSaveButton } from '../ChamProjects/ChamProjects';

import styles from './TopMenu.module.css';
import closeIcon from './assets/close.svg';
import openIcon from './assets/open.svg';

export default function TopMenu({ extended, onHelpClick }) {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isHelpOpen, setIsHelpOpen] = useState(false);
    const [isShareOpen, setIsShareOpen] = useState(false);
    const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
    const menuRef = useRef(null);
    
    // TODO: Get these from Redux when visualizer is implemented
    // const currentView = useSelector(state => state.app.currentView);
    // const currentImageUrl = useSelector(state => state.app.currentImageUrl);
    // const style = useSelector(state => state.app.style);
    // const size = useSelector(state => state.app.size);
    // const activeProfile = useSelector(state => state.app.activeProfile);
    // const productSelection = useSelector(state => state.app.productSelection);
    // const roomscene = useSelector(state => state.app.roomscene);

    extended = true;

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && isMobileMenuOpen) {
                setIsMobileMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMobileMenuOpen]);

    const handleMenuTriggerClick = function () {
        setIsMobileMenuOpen(status => !status);
    }

    const closeMenu = () => {
        setIsMobileMenuOpen(false);
    }

    const handleShareModalButtonClick = function () {
        setIsShareOpen(true);
        closeMenu();
    }

    const handleFeedbackModalButtonClick = function () {
        setIsFeedbackOpen(true);
        closeMenu();
    }

    const handleHelpButtonClick = function () {
        if (onHelpClick) {
            onHelpClick();
        } else {
            setIsHelpOpen(true);
        }
        closeMenu();
    }

    const handleStartOverClick = function () {
        // Clear all localStorage to reset app state
        localStorage.clear();
        window.location.href = '/';
        closeMenu();
    }

    return (
        <>
            <section className={styles.topMenu} ref={menuRef}>
                <nav aria-label="Main Navigation">
                    <div className={styles.menuTrigger}>
                        <button onClick={handleMenuTriggerClick} aria-expanded={isMobileMenuOpen} aria-controls="main-menu">
                            <span aria-hidden="true">
                                {!isMobileMenuOpen && <img src={openIcon} alt='open icon' />}
                                {isMobileMenuOpen && <img src={closeIcon} alt='close icon' />}
                            </span>
                        </button>
                    </div>

                    <ul className={!isMobileMenuOpen ? styles.closed : ''}>
                        <div className={styles.rightNav}>
                            {extended && (<>
                                <li>
                                    <button type="button" onClick={handleStartOverClick} aria-label="Start Over">
                                        <span>Start Over</span>
                                    </button>
                                </li>

                                <li>
                                    <ChamProjectsOpenButton title="My Projects" className="" aria-label="My Projects Button" />
                                </li>

                                <li>
                                    <ChamProjectsSaveButton title="Save" className="" aria-label="Save Button" />
                                </li>

                                <li>
                                    <button type="button" onClick={handleFeedbackModalButtonClick} aria-label="Feedback">
                                        <span>Feedback</span>
                                    </button>
                                </li>

                                <li>
                                    <button onClick={handleHelpButtonClick}>Visualizer Help</button>
                                </li>

                                <li className={styles.altNav}>
                                    <button type="button" onClick={handleShareModalButtonClick} aria-label="Share">
                                        <span>Share/Email</span>
                                    </button>
                                </li>

                                <li className={styles.altNav}>
                                    <PrintLink onClick={closeMenu} />
                                </li>
                            </>)}
                        </div>
                    </ul>
                </nav>
            </section>

            <HelpModal 
                isOpen={isHelpOpen}
                onClose={() => setIsHelpOpen(false)}
            />

            <ShareModal 
                isOpen={isShareOpen}
                onClose={() => setIsShareOpen(false)}
            />

            <FeedbackModal 
                isOpen={isFeedbackOpen}
                onClose={() => setIsFeedbackOpen(false)}
            />
        </>
    );
}

